import React, { useContext } from 'react';
import { GlobalContext } from '../../contexts/GlobalContext';
import Breadcrumb from '../../components/Breadcrumb/Breadcrumb';
import PageTitle from '../../components/PageTitle/PageTitle';


const Regulations = () => {
    const { state } = useContext(GlobalContext);
    const language = state.language || 'pt-br';
    const data = require(`../../assets/languages/${language}/regulations.json`);
    const {
        breadcrumb,
        selectedPage,
        pageTitle,
        regulationsItens
    } = data

    return (
        <>
            <Breadcrumb
                beforeRoutes={breadcrumb}
                selectedPage={selectedPage}
                ignoreMgBot={true}
            />
            <div className='main-container'>
                <section className="section-container">
                    <PageTitle title={pageTitle} />
                    {regulationsItens?.map((d, i) => {
                        return (
                            <>
                                <span className='text-title-secondary mg-bot-20'>{d.label}</span>
                                <span dangerouslySetInnerHTML={{ __html: d.value }} className={`mg-bot-${i + 1 === regulationsItens.length ? '100' : '70'}`}></span>
                            </>
                        )
                    })}

                </section>
            </div>
        </>
    )
}

export default Regulations